import { ListItem, TableRow, styled } from "@mui/material";
import { Typography, type TypographyProps } from "@platform/design-system";

import type { Theme } from "@mui/material/styles";
import type { ElementType } from "react";

export const StyledBaseRow = styled(TableRow)(
  ({ theme }: { theme: Theme }) => ({
    ".MuiTableCell-root": {
      "&:first-of-type": {
        width: 290,
      },
      "&:not(:first-of-type)": {
        minWidth: 430,
        borderLeft: `1px solid ${theme.palette.neutrals.neutral_300}`,
      },
    },
  }),
);

export const StyledTableRow = styled(StyledBaseRow, {
  shouldForwardProp: (prop) =>
    !["isWhite", "isCustom"].includes(prop as string),
})<{ isWhite?: boolean }>(
  ({ theme, isWhite }: { theme: Theme; isWhite?: boolean }) => ({
    backgroundColor: isWhite ? "white" : theme.palette.neutrals.neutral_50,
    ".MuiTableCell-root:first-of-type": {
      backgroundColor: isWhite ? "white" : theme.palette.neutrals.neutral_50,
    },
  }),
);

export const StyledListItem = styled(ListItem, {
  shouldForwardProp: (prop) =>
    !["justifyContent", "fontWeight"].includes(prop as string),
})<{ justifyContent: string; fontWeight?: string; component?: ElementType }>(
  ({
    theme,
    justifyContent = "flex-start",
    fontWeight,
  }: {
    theme: Theme;
    justifyContent?: string;
    fontWeight?: string;
  }) => ({
    flex: 1,
    borderBottom: "none",
    fontSize: theme.typography.body2.fontSize,
    display: "flex",
    alignItems: "center",
    justifyContent,
    padding: 0,
    fontWeight,
  }),
);

export const StyledTableSectionRow = styled(StyledBaseRow)(
  ({ theme }: { theme: Theme }) => ({
    backgroundColor: theme.palette.surfaces.primary,
    cursor: "pointer",
  }),
);

export const StyledTypography = (props: TypographyProps): React.JSX.Element => (
  <Typography variant="body-medium" {...props} />
);
